import React from 'react';
import { Bell } from 'react-bootstrap-icons';
import { Container } from 'react-bootstrap';

const EmptyNotificationsMessage = () => {
  return (
    <Container 
      className="d-flex flex-column align-items-center justify-content-center" 
      style={{ minHeight: '50vh' }}
    >
      <Bell size={48} style={{ color: 'var(--text-tertiary)' }} />
      <p 
        className="mt-3 text-center" 
        style={{ 
          fontSize: '1.2rem',
          color: 'var(--text-secondary)',
          fontFamily: 'var(--site-font)'
        }}
      >
        You aren't following any topics for this country, to follow feeds go to notifications.
      </p>
    </Container>
  );
};

export default EmptyNotificationsMessage;